export default __webpack_public_path__ + "static/media/icon-4.0dc181a1.svg";